import { Helmet } from "react-helmet";
import {
    Box,
    Switch,
    FormGroup,
    FormControlLabel,
    Divider,
    ListItem,
    Typography,
    Checkbox,
    Paper
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { styled } from '@mui/material/styles';
import { DropResult, DragDropContext, Droppable, OnDragEndResponder, Draggable } from 'react-beautiful-dnd';
import Icon from '@mui/material/Icon';
import { ReactComponent as MoveIcon } from "../../../assets/icons/move.svg";
import { ReactComponent as EditIcon } from "../../../assets/icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/delete.svg";
import * as Util from "../../../services/global.service";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { Link as RouterLink, useNavigate } from "react-router-dom";
import SimpleDialog from "../../../components/SimpleDialog";
import ConfirmDialog from "../../../components/ConfirmDialog";
import adminService from "../../../services/admin.service";
import MessageDialog from "../../../components/inbox/MessageDialog";
import { listGoalProgress } from "../../../actions/admin";
import { useSelector, useDispatch } from "react-redux";

const useStyles = makeStyles({
    draggingListItem: {
        background: 'rgb(235,235,235)'
    },
    flexPaper: {
        flex: 1,
        margin: 16,
        minWidth: 350
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    }
});
const styles = {

};

const GoalComponent = ({ item, index, search, lastindex, link, serial }: DraggableListItemProps) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    useEffect(() => {

    }, []);

    const BootstrapTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: "#343A40",
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#343A40",
            color: "#FFFFFF",
            padding: "11px 15px",
        },
    }));
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false);
    const [itemDel, setItemDel] = React.useState("");
    const handleConfirmDeleteDialog = (val, serial) => {
        if (val === false) {
            setItemDel("")
            dispatch({
                type: "SET_DELECT_PROGRESS",
                payload: "",
            });
        }
        openConfirmDeleteDialog(val);
    };
    const handleConfirmDeleteList = () => {
        dispatch({
            type: "SET_DELECT_PROGRESS",
            payload: itemDel,
        });
        openConfirmDeleteDialog(false)
    };

    const handleDeleteClick = React.useCallback((e, data) => {
        e.stopPropagation();
        e.preventDefault();
        setItemDel(data)
        handleConfirmDeleteDialog(true, data)
    }, []);
    return (
        <Draggable draggableId={`${item.seq}`} index={index}>
            {(provided, snapshot) => (
                <ListItem sx={{ padding: "0", "padding-left": "40px", "padding-right": "40px", "flex-direction": "column" }}
                    ref={provided.innerRef}
                    {...provided.draggableProps}>
                    {/* <Box sx={{ width: "100%", position: "relative", "&:before": { content: '""', position: 'absolute', height: index === 1 ? "100%" : "0px", width: index === 1 ? "100%" : "0px", top: "0", background: "#FAFAFA", opacity: "0.7" }, }}> */}
                    <Box sx={{ width: "100%", position: "relative" }}>
                        <Box
                            sx={{ height: "96px", background: "#FFF", "box-shadow": snapshot.isDragging ? "0 0.375rem 0.875rem 0 rgb(0 0 0 / 13%), 0 0.0625rem 0.25rem 0 rgb(0 0 0 / 11%)" : "", width: "100%", display: "flex", "align-items": "center" }}
                            px="25px"
                        >
                            <Box sx={{ width: "100px" }} pr="15px">
                                {item?.is_default === true ? <Checkbox sx={{ pointerEvents: "none" }} checked={true} /> : null}
                            </Box>
                            <Box sx={{ width: "calc(20% - 40px)" }} pr="15px">
                                {/* <Box py="8px" px="20px" sx={{ "min-width": "120px", "max-width": "100%", width: "max-content", border: item?.type === "not_started" ? "1px solid #DADADA" : "", "border-radius": "5px", background: item?.type === "not_started" ? "" : "rgba(242, 142, 43, 0.1)" }} > */}
                                <Box py="8px" px="20px" sx={{ "max-width": "100%", width: "max-content", border: item?.type === "not_started" ? "1px solid #DADADA" : "", "border-radius": "5px", background: item?.color?.background }} >
                                    <Typography fontSize={16} lineHeight="24px" fontWeight={500} color={item?.color?.font} sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                        {item?.options?.name_en !== undefined && item?.options?.name_en !== null ? item?.options?.name_en : item?.name}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ width: "calc(20% - 40px)" }} pr="15px">
                                {/* <Box py="8px" px="20px" sx={{ "min-width": "120px", "max-width": "100%", width: "max-content", border: item?.type === "not_started" ? "1px solid #DADADA" : "", "border-radius": "5px", background: item?.type === "not_started" ? "" : "rgba(242, 142, 43, 0.1)" }} > */}
                                {item?.options?.name_th !== null && item?.options?.name_th !== undefined && item?.options?.name_th !== "" ?
                                    <Box py="8px" px="20px" sx={{ "max-width": "100%", width: "max-content", border: item?.type === "not_started" ? "1px solid #DADADA" : "", "border-radius": "5px", background: item?.color?.background }} >
                                        <Typography fontSize={16} lineHeight="24px" fontWeight={500} color={item?.color?.font} sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                            {item?.options?.name_th}
                                        </Typography>
                                    </Box>
                                    :
                                    null
                                }
                            </Box>
                            <Box sx={{ width: "calc(26% - 40px)" }} pr="15px">
                                <Typography fontWeight="500" fontSize={18} lineHeight="27px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {item?.options?.name_en !== undefined && item?.options?.name_en !== null ? item?.options?.name_en : item?.name}
                                </Typography>
                                <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {item?.options?.name_th}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "column", width: "calc(17% - 40px)" }} pr="15px">
                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {item?.created_by?.fullname !== undefined && item?.created_by?.fullname !== null ? item?.created_by?.fullname : item?.created_at !== undefined && item?.created_at !== null && item?.created_at !== "" ? "Default" : ""}
                                </Typography>
                                <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {Util.dateDayTimeFormatAdmin(item?.created_at)}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "column", width: "calc(17% - 40px)" }} pr="15px">
                                <Typography fontWeight="400" fontSize={16} lineHeight="24px" sx={{ color: "#404349", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {item?.updated_by?.fullname !== undefined && item?.updated_by?.fullname !== null ? item?.updated_by?.fullname : item?.updated_at !== undefined && item?.updated_at !== null && item?.updated_at !== "" ? "Default" : ""}
                                </Typography>
                                <Typography fontWeight="400" fontSize={14} lineHeight="21px" sx={{ color: "#A3A3A3", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                    {Util.dateDayTimeFormatAdmin(item?.updated_at)}
                                </Typography>
                            </Box>
                            <Box sx={{ display: "flex", "flex-direction": "row", width: "100px", "z-index": "1", "justify-content": "center" }}>
                                {item?.type !== "not_started" && item?.type !== "completed" ?
                                    search !== "" ?
                                        <Box>
                                            <MoveIcon style={{ opacity: "0.2", cursor: "no-drop", pointerEvents: "none" }} />
                                        </Box>
                                        :
                                        <Box {...provided.dragHandleProps}>
                                            <BootstrapTooltip title={`Move`} placement="top">
                                                <MoveIcon />
                                            </BootstrapTooltip>
                                        </Box>
                                    :
                                    null
                                }
                                <Box px="20px">
                                    <BootstrapTooltip title={`Edit`} placement="top">
                                        <EditIcon style={{ cursor: "pointer" }} onClick={() => { clickLink(link + item.serial) }} />
                                    </BootstrapTooltip>
                                </Box>
                                {item?.type !== "not_started" && item?.type !== "completed" && item?.is_used !== true ?
                                    <Box>
                                        <BootstrapTooltip title={`Delete`} placement="top">
                                            <DeleteIcon style={{ cursor: "pointer" }} onClick={(e) => { handleDeleteClick(e, item.serial) }} />
                                        </BootstrapTooltip>
                                    </Box>
                                    :
                                    null
                                }
                            </Box>
                        </Box>
                    </Box>
                    <Divider width="100%" />
                    <ConfirmDialog
                        open={isConfirmDeleteDialogOpen}
                        trash={true}
                        doConfirm={handleConfirmDeleteList}
                        setValue={handleConfirmDeleteDialog}
                        title={t('label.confirmationofDeletion')}
                        text={t('admin.label.GoalProgressDeletedConfirmation')}
                    />
                </ListItem >
            )
            }
        </Draggable >
    );
};
export default GoalComponent;
